<script setup lang="ts">
import {ModelList} from '@jantm/model-core'
import Dashboard from "@/components/WiserDashboardComponent.vue";
import type {InvoiceFilter} from "@/types/Wiser/invoice.ts";
import {ref} from "vue";
import InvoiceFilterForm from "@/views/Wiser/InvoiceFilterForm.vue";
const modelFilter = ref<InvoiceFilter>({page: '1', perPage: '25'});
</script>

<template>
  <Dashboard />
  <div class="container">
    <InvoiceFilterForm v-model="modelFilter" />
    <ModelList class="model-list model-list-invoice" model="Invoice" :filter="modelFilter" />
  </div>
</template>

<style scoped></style>
